import isBrowser from '../isBrowser';
import getCookie from './cookies';

const getUsernameCookie = () => {
  if (isBrowser()) {
    return window.atob(getCookie('username') || '');
  }

  return undefined;
};

export default getUsernameCookie;
